
import { Box, Paper, Table, TableBody, TableCell, TableHead } from "@mui/material";
import styled from "styled-components";

export const InfoCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  borderRadius: theme.spacing(2), // or theme.palette.custom.borderRadius if available
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
}));

export const IconWrapper = styled(Box)<{ bgcolor?: string; color?: string }>(({ theme, bgcolor, color }) => ({
  backgroundColor: bgcolor || theme.palette.grey[100],
  color: color || theme.palette.primary.main,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 48,
  minHeight: 48,
}));

export const StatusChip = styled(Box)<{ status: string }>(({ theme, status }) => {
  let bgcolor = theme.palette.grey[200];
  let color = theme.palette.text.primary;

  switch (status.toLowerCase()) {
    case 'ongoing':
      bgcolor = '#E3F2FD'; // Light blue
      color = '#1976D2'; // Blue
      break;
    case 'completed':
      bgcolor = '#E8F5E9'; // Light green
      color = '#2E7D32'; // Green
      break;
    default:
      break;
  }

  return {
    backgroundColor: bgcolor,
    color: color,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(1),
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'inline-block',
  };
});

export const StyledTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[200]}`,
  overflowX: 'auto',
  boxShadow: 'none',
}));

export const StyledTable = styled(Table)({
  minWidth: 800,
  borderCollapse: 'separate',
  borderSpacing: 0,
});

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,

  '& th': {
    backgroundColor: 'inherit',
    color: theme.palette.custom.sidebarText,
    fontWeight: 600,
    fontSize: '0.85rem',
    borderBottom: 'none',
    padding: theme.spacing(1.5, 2),
  },
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  '& tr:nth-of-type(odd)': {
    backgroundColor: theme.palette.white.main,
  },
  '& tr:nth-of-type(even)': {
    backgroundColor: theme.palette.primary.light,
  },
  '& tr:last-child td': {
    borderBottom: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.85rem',
  color: theme.palette.custom.sidebarText,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(1.5, 2),
}));

export const PaginationFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: theme.spacing(2),
  color: theme.palette.grey[600],
  fontSize: '0.85rem',
  paddingBottom: 0,
}));
